export class SearchCifrasControlFilters {
    idTipoArchivo:number;
    fechaInicio:Date;
    fechaFin:Date;

    constructor() {
      this.idTipoArchivo = null;
      this.fechaInicio = null;
      this.fechaFin = null;
    }
  }